"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _optionList = _interopRequireDefault(require("@amzn/meridian-tokens/component/option-list"));
var _optionListGroup = _interopRequireDefault(require("./option-list-group"));
var _styles = _interopRequireDefault(require("./styles"));
var _theme = require("../theme");
var _token = require("./../_utils/token");
var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var isGroup = (0, _isElementOf["default"])(_optionListGroup["default"]);

/**
 * This component helps render a keyboard-friendly list of selectable options.
 */
/* eslint-disable react/prop-types */
var OptionListClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionListClass, _React$Component);
  var _super = _createSuper(OptionListClass);
  function OptionListClass() {
    var _this;
    (0, _classCallCheck2["default"])(this, OptionListClass);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      preselectedIndex: _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.props.defaultPreselectedIndex !== undefined ? _this.props.defaultPreselectedIndex : -1
    });
    // Generate a unique id that can be used to reference this element in the DOM
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("option-list-"));
    // Track the DOM node for each option so we can scroll to it using
    // `Element.scrollIntoView`
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionDomNodes", []);
    // Track the list DOM node so we can manage focus (see `focusOnMount`)
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "listDomNode", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "allOptions", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedIndex", function (options) {
      return (0, _findIndex["default"])(options, function (option) {
        return option && option.props.selected;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPreselectedIndex", function () {
      return _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.state.preselectedIndex;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextPreselectedIndex", function (offset) {
      var options = _this.allOptions;
      var preselectedIndex = _this.getPreselectedIndex();
      var selectedIndex = _this.getSelectedIndex(options);
      var enabledIndices = options.reduce(function (result, option, index) {
        if (option && !option.props.disabled) {
          result.push(index);
        }
        return result;
      }, []);
      var firstIndex = enabledIndices[0];
      var lastIndex = enabledIndices[enabledIndices.length - 1];
      // If we've got a preselected or a selected option then move to the prev or
      // next option in the list (depending on the value of offset).
      var currentIndex = preselectedIndex !== -1 ? preselectedIndex : selectedIndex;
      if (currentIndex !== -1) {
        var nextIndex = enabledIndices[enabledIndices.indexOf(currentIndex) + offset];
        return nextIndex !== undefined ? nextIndex : offset < 0 ? firstIndex : lastIndex;
        // If we don't have a preselected or selected option and we were trying to
        // move up, preselect the option at the bottom of the list.
      } else if (offset < 0) {
        return lastIndex;
        // If we don't have a preselected or selected option and we were trying to
        // move down, preselect the option at the top of the list.
      } else {
        return firstIndex;
      }
    });
    // Focuses on an option dom node based on index. Returns `true` on success
    // and `false` on a failure
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusOptionByIndex", function (index) {
      var optionDomNode = _this.optionDomNodes[index];
      if (optionDomNode) {
        optionDomNode.focus();
        return true;
      } else {
        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function (preselectedIndex) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          focus: true
        },
        focus = _ref.focus;
      if (_this.props.preselectedIndex === undefined) {
        _this.setState({
          preselectedIndex: preselectedIndex
        });
        if (focus) {
          _this.focusOptionByIndex(preselectedIndex);
        }
      }
      _this.props.onChangePreselectedIndex(preselectedIndex);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownContainer", function (event) {
      // Call the user's key down handler first. If they prevent the default event
      // behavior, don't run any of our code.
      _this.props.onKeyDown(event);
      if (!event.defaultPrevented) {
        var key = event.key;
        var keyUsed = false;

        // Move the preselection up or down in the list when the up arrow is pressed
        if (key === "ArrowUp" || key === "ArrowDown") {
          var preselectedIndex = _this.getNextPreselectedIndex(key === "ArrowUp" ? -1 : 1);
          _this.onChangePreselectedIndex(preselectedIndex);
          _this.scrollOptionIntoView(preselectedIndex);
          keyUsed = true;
        }

        // Simulate a click on the current preselected option when enter or space is
        // pressed
        if (key === "Enter" || key === " ") {
          var _preselectedIndex = _this.getPreselectedIndex();
          var option = _this.allOptions[_preselectedIndex];
          if (option && !option.props.disabled) {
            _this.allOptions[_preselectedIndex].props.onClick();
          }
          keyUsed = true;
        }

        // Don't perform the normal action associated with the key (i.e. scroll for
        // arrows) if the key was used for an option list action
        if (keyUsed) {
          event.preventDefault();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionRef", function (index) {
      return function (domNode) {
        return _this.optionDomNodes[index] = domNode;
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollOptionIntoView", function (index) {
      var optionDomNode = _this.optionDomNodes[index];
      if (optionDomNode) {
        optionDomNode.scrollIntoView(optionDomNode);
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(OptionListClass, [{
    key: "focus",
    value: function focus() {
      var _this$forwardedRef, _this$forwardedRef$cu;
      return (_this$forwardedRef = this.forwardedRef) === null || _this$forwardedRef === void 0 ? void 0 : (_this$forwardedRef$cu = _this$forwardedRef.current) === null || _this$forwardedRef$cu === void 0 ? void 0 : _this$forwardedRef$cu.focus();
    }
  }, {
    key: "processChildren",
    value: function processChildren() {
      var _this2 = this;
      var preselectedIndex = this.state.preselectedIndex;
      var id = this.props.id || this.id;
      var processedChildren = [];
      // Rest option counter to 0
      var optionCounter = 0;
      // Reset allOptions which tracks option components (no group components)
      this.allOptions = [];
      _react["default"].Children.toArray(this.props.children).forEach(function (child) {
        if (!child) {
          return;
        } else if (isGroup(child)) {
          var _this2$allOptions;
          var updatedGroup = /*#__PURE__*/_react["default"].cloneElement(child, child.props, _react["default"].Children.map(child.props.children, function (option, i) {
            var index = optionCounter + i;
            return /*#__PURE__*/_react["default"].cloneElement(option, {
              ref: _this2.optionRef(index),
              id: "".concat(id, "-").concat(child.props.role, "-").concat(index),
              // If "child" (the group) is disabled then disable all of its options
              disabled: child.props.disabled || option.props.disabled,
              preselected: index === preselectedIndex,
              showIndicator: _this2.props.multiSelectable,
              onChangePreselected: function onChangePreselected(preselected) {
                return (
                  // Don't shift focus on mouse over
                  _this2.onChangePreselectedIndex(preselected ? index : -1, {
                    focus: false
                  })
                );
              }
            });
          }));
          // Update allOptions tracker
          _this2.allOptions = (_this2$allOptions = _this2.allOptions).concat.apply(_this2$allOptions, (0, _toConsumableArray2["default"])(updatedGroup.props.children));
          // Push onto array
          processedChildren.push(updatedGroup);
          // Update option counter
          optionCounter += updatedGroup.props.children.length;
        } else {
          var index = optionCounter;
          var updatedOption = /*#__PURE__*/_react["default"].cloneElement(child, {
            ref: _this2.optionRef(index),
            id: "".concat(id, "-item-").concat(index),
            preselected: index === preselectedIndex,
            showIndicator: _this2.props.multiSelectable,
            onChangePreselected: function onChangePreselected(preselected) {
              return (
                // Don't shift focus on mouse over
                _this2.onChangePreselectedIndex(preselected ? index : -1, {
                  focus: false
                })
              );
            }
          });
          // Update allOptions tracker
          _this2.allOptions = _this2.allOptions.concat(updatedOption);
          // Push onto array
          processedChildren.push(updatedOption);
          // Update option counter
          optionCounter += 1;
        }
      });
      return processedChildren;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$forwarded;
      if ((_this$props$forwarded = this.props.forwardedRef) !== null && _this$props$forwarded !== void 0 && _this$props$forwarded.current) {
        // `forwardedRef` returns the div element returned by this component's render
        // The following lines are allowing the parent to call this class component's methods directly
        this.props.forwardedRef.current.getNextPreselectedIndex = this.getNextPreselectedIndex;
        this.props.forwardedRef.current.onChangePreselectedIndex = this.onChangePreselectedIndex;
        this.props.forwardedRef.current.scrollOptionIntoView = this.scrollOptionIntoView;
      }
      // Scroll the preselected or selected option into view on mount
      var preselectedIndex = this.getPreselectedIndex();
      if (preselectedIndex !== -1) {
        this.scrollOptionIntoView(preselectedIndex);
      } else {
        this.scrollOptionIntoView(this.getSelectedIndex(this.allOptions));
      }

      // Focus on mount
      if (this.props.inaccessibleAutoFocus) {
        // NOTE: React guarantees that callback refs will be resolved before
        // componentDidMount is called, so this is safe.
        this.focus();
      }

      // If the option list is for a Menu, focus the first menu item.
      // See ARIA Menu role specs:
      // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/menu_role
      if (this.props.role === "menu") {
        this.onChangePreselectedIndex(0, {
          focus: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        preselectedIndex = _this$props.preselectedIndex,
        defaultPreselectedIndex = _this$props.defaultPreselectedIndex;
      // If the preselected index was changed via props, update the internal state
      if (preselectedIndex !== undefined && preselectedIndex !== prevProps.preselectedIndex) {
        this.setState({
          preselectedIndex: preselectedIndex
        });
        this.focusOptionByIndex(preselectedIndex);
      } else if (preselectedIndex === undefined && defaultPreselectedIndex !== undefined && defaultPreselectedIndex !== prevProps.defaultPreselectedIndex) {
        this.setState({
          preselectedIndex: defaultPreselectedIndex
        });
        // If the default was changed then scroll it into view. We don't do this
        // if the `preselectedIndex` prop is changed because that means the parent
        // component is fully managing state and will need to be responsible for
        // managing scroll position as well.
        this.scrollOptionIntoView(defaultPreselectedIndex);
        if (this.props.recalculateFocusOnUpdate) {
          this.focusOptionByIndex(defaultPreselectedIndex);
        }
      }
      // Always refocus on update in case the options move around and between groups
      // which could break React's connection with the underlying elements
      else if (this.props.recalculateFocusOnUpdate) {
        var _preselectedIndex2 = this.state.preselectedIndex;
        if (_preselectedIndex2 >= 0) {
          var successfulFocus = this.focusOptionByIndex(_preselectedIndex2);
          // If focusing on the preselected index was not successful, see if it was
          // because the option list shrunk
          if (!successfulFocus) {
            var filteredDomNodeList = this.optionDomNodes.filter(function (option) {
              return option;
            });
            // If the list shrank and the preselected index now exceeds the number
            // of valid options, focus on the last valid option
            if (_preselectedIndex2 > filteredDomNodeList.length - 1) {
              this.setState({
                preselectedIndex: filteredDomNodeList.length - 1
              });
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var props = this.props;
      var id = props.id || this.id;
      var children = this.processChildren();
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _optionList["default"],
        map: (0, _token.getTokenHelper)("optionList")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this3.props.forwardedRef,
          onKeyDown: _this3.onKeyDownContainer,
          tabIndex: "0",
          role: props.role,
          "aria-multiselectable": props.multiSelectable,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          className: (0, _styles["default"])(t),
          id: id
        }, children);
      });
    }
  }]);
  return OptionListClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
(0, _defineProperty2["default"])(OptionListClass, "defaultProps", {
  role: "listbox",
  onKeyDown: _noop["default"],
  onChangePreselectedIndex: _noop["default"]
});
var OptionList = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(OptionListClass, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});
OptionList.displayName = "OptionList";
OptionList.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A set of OptionListItem nodes.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * The index of the default "preselected" option. The "preselected" option
   * is the option that is highlighted and will be selected if the user
   * presses enter or space on their keyboard.
   *
   * NOTE: This is an uncontrolled component by default. It tracks the
   * preselected index using internal state. If the value of this prop changes
   * the internal state will be updated to reflect the new value, but
   * subsequent user interaction with the component may change the internal
   * state. To use make this component behave like a controlled component, use
   * the "preselectedIndex" and "onChangePreselectedIndex" props below.
   *
   */
  defaultPreselectedIndex: _propTypes["default"].number,
  /**
   * Sets an `id` attribute on the listbox element.
   */
  id: _propTypes["default"].string,
  /**
   * If set to true then the option list will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,
  /**
   * If set to true if more than one option may be selected at once.
   */
  multiSelectable: _propTypes["default"].bool,
  /**
   * Use this to fix the index of the "preselected" option. This will disable
   * the internal state used to track the preselected index.
   */
  preselectedIndex: _propTypes["default"].number,
  /**
   * Set to true to have the option list continuously recalculate which list item
   * to focus. Helpful when the list might have options move disappear or move.
   */
  recalculateFocusOnUpdate: _propTypes["default"].bool,
  role: _propTypes["default"].string,
  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,
  /**
   * This is called any time the OptionList wants to update the preselected
   * index
   */
  onChangePreselectedIndex: _propTypes["default"].func,
  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,
  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   *
   * If `event.preventDefault()` is called from this handler then the option
   * list's default keyboard behavior will be prevented.
   */
  onKeyDown: _propTypes["default"].func
} : {};
var _default = OptionList;
exports["default"] = _default;